<template>
	<div class="unishop-unifilter tickets-aparcados">
		<div class="uf-filter-wrap">
			<div id="uf-category" class="uf-filter">
				<div class="uf-title">Fecha</div>
					<v-menu
						v-model="menu1"
						:close-on-content-click="false"
						:nudge-top="-100"
						transition="scale-transition"
						offset-y
						attach
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="fechaDesde"
								label="Desde"
								readonly
								append-icon="event"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker locale="es" v-model="fechaDesde" no-title @input="menu1 = false"></v-date-picker>
					</v-menu>
					<v-menu
						v-model="menu2"
						:close-on-content-click="false"
						:nudge-top="-180"
						transition="scale-transition"
						attach
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="fechaHasta"
								label="Hasta"
								readonly
								append-icon="event"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker locale="es" v-model="fechaHasta" no-title @input="menu2 = false"></v-date-picker>
					</v-menu>
				</div>
		</div>
		<div class="uf-search-wrap">
			<div id="uf-name" class="uf-search">
				<div class="uf-title">Cliente</div>
				<div class="uf-search-box">
					<!-- <input type="search" placeholder="Type here.."> -->
					<input
						class="input is-rounded"
						type="text"
						v-model="cliente"
						placeholder="Buscar"
					>
					<div class="uf-reset" title="Reset" @click="cliente=''">
					</div>
				</div>
			</div>
		</div>
		<div class="uf-search-wrap">
			<div id="uf-name" class="uf-search">
				<div class="uf-title">Vendedor</div>
				<div class="uf-search-box">
					<!-- <input type="search" placeholder="Type here.."> -->
					<input
						class="input is-rounded"
						type="text"
						v-model="vendedor"
						placeholder="Buscar"
					>
					<div class="uf-reset" title="Reset" @click="vendedor=''">
					</div>
				</div>
			</div>
		</div>
		<div class="uf-filter-wrap">
			<div id="uf-category" class="uf-filter">
				<div class="uf-title">Tipo ticket:</div>
				<multiselect 
					v-model="tipo" 
					label="nombre" 
					track-by="id" 
					:options="tiposTicket" 
					:multiple="false" 
					:taggable="false"
					:searchable="false"
					:show-labels="false"
				>
				</multiselect>
			</div>
		</div>
		<div class="d-flex justify-end">
			<v-btn flat icon class="primary no-flex" @click="reset()"><v-icon>restart_alt</v-icon></v-btn>
			<v-btn flat fab class="orange white--text no-flex mx-0" @click="search()"><v-icon>search</v-icon></v-btn>
		</div>	
	</div>
</template>

<script>
import 'vue-slider-component/theme/material.css'
import Multiselect from 'vue-multiselect'

export default {
	name: 'filtroTicketsAparcados',
	components: {
    Multiselect
  },
	data () {
		return {
			vendedor: '',
			cliente: '',
			menu1: false,
			menu2: false,
			fechaDesde: '',
			fechaHasta: '',
			tiposTicket: [{nombre:'Todos', id : 2},{nombre:'Tienda', id : 0},{nombre:'Reserva', id : 1}],
			tipo: '',
		}
	},
	mounted () {
		this.vendedor = this.$store.state.userInfo.ticketVendedorSearched
		this.cliente = this.$store.state.userInfo.ticketClienteSearched
		this.fechaDesde = this.$store.state.userInfo.ticketFechaDesdeSearched
		this.fechaHasta = this.$store.state.userInfo.ticketFechaHastaSearched
		if (this.$store.state.userInfo.ticketTipoSearched === '') {
			this.tipo = {nombre:'Todos', id : 2}
		} else {
			this.tipo = this.$store.state.userInfo.ticketTipoSearched
		}
	},
	methods: {
		search () {
			this.$store.commit('setTicketClienteSearched', this.cliente);
			this.$store.commit('setTicketVendedorSearched', this.vendedor);
			this.$store.commit('setTicketFechaDesdeSearched', this.fechaDesde);
			this.$store.commit('setTicketFechaHastaSearched', this.fechaHasta);
			this.$store.commit('setTicketTipoSearched', this.tipo);
      this.$store.commit('setHasTicketSearched', this.$store.state.userInfo.hasTicketSearched + 1);
      this.$store.commit('showFiltroTickets', false);
		},
		reset () {
			this.cliente =''
			this.vendedor = ''
			this.fechaDesde = ''
			this.fechaHasta = '' 
			this.tipo = {nombre:'Todos', id : 2}
			this.$store.commit('setHasTicketSearched', 0);
			this.$store.commit('setTicketClienteSearched', this.cliente);
			this.$store.commit('setTicketVendedorSearched', this.vendedor);
			this.$store.commit('setTicketFechaDesdeSearched', this.fechaDesde);
			this.$store.commit('setTicketFechaHastaSearched', this.fechaHasta);
			this.$store.commit('setTicketTipoSearched', this.tipo);
			this.$store.commit('showFiltroTickets', false);
		}
	}
}
</script>

